import { SupportedLanguage } from "../../../config/languages";
import { resolveLinkUrl } from "../../../helpers/linkHelpers";
import { Navigation } from "../../../payload-types";
import { Link } from "../../Link/Link";
import { NavDropdownColumn } from "../types";
import classNames from "classnames/bind";
import styles from "./NavDropdown.module.css";

const cx = classNames.bind(styles);

interface NavDropdownProps {
  columns?: Navigation["menuItems"][0]["dropdownColumns"];
  isOpen: boolean;
  currentLang: SupportedLanguage;
  variant?: "default" | "dark";
  isScrolled?: boolean;
  dropdownId?: string;
  onClick: () => void;
  onDropdownKeyDown?: (e: React.KeyboardEvent) => void;
}

export const NavDropdown = ({
  columns,
  isOpen,
  currentLang,
  variant = "default",
  isScrolled = false,
  dropdownId,
  onClick,
  onDropdownKeyDown,
}: NavDropdownProps) => {
  if (!columns || columns.length === 0) {
    return null;
  }

  return (
    <div
      className={cx("dropdown")}
      data-open={isOpen}
      data-variant={variant}
      data-scrolled={isScrolled}
      id={dropdownId}
      role="menu"
      aria-hidden={!isOpen}
      onKeyDown={onDropdownKeyDown}
    >
      <div className={cx("columns")}>
        {columns.map((column: NavDropdownColumn, columnIndex: number) => (
          <div key={columnIndex} className={cx("column")}>
            {column.headerLink &&
              (resolveLinkUrl(column.headerLink, "url") ? (
                <Link
                  href={resolveLinkUrl(column.headerLink, "url") || ""}
                  className={cx("headerLink")}
                  openInNewTab={column.headerLink.openInNewTab || false}
                  locale={currentLang}
                  onClick={onClick}
                >
                  {column.headerLink.label}
                </Link>
              ) : (
                <div className={cx("headerText")}>
                  {column.headerLink.label}
                </div>
              ))}
            {column.links && column.links.length > 0 && (
              <div className={cx("links")}>
                {column.links.map(
                  (
                    link: NonNullable<NavDropdownColumn["links"]>[0],
                    linkIndex: number,
                  ) => (
                    <div key={linkIndex} className={cx("linkWrapper")}>
                      <Link
                        href={resolveLinkUrl(link, "url") || ""}
                        className={cx("link")}
                        openInNewTab={link.openInNewTab || false}
                        locale={currentLang}
                        onClick={onClick}
                      >
                        <span className={cx("linkLabel")}>{link.label}</span>
                      </Link>
                      {link.listItems && link.listItems.length > 0 && (
                        <ul className={cx("linkList")}>
                          {link.listItems.map(
                            (
                              item: NonNullable<typeof link.listItems>[0],
                              itemIndex: number,
                            ) => (
                              <li
                                key={itemIndex}
                                className={cx("linkListItem")}
                              >
                                {item.text}
                              </li>
                            ),
                          )}
                        </ul>
                      )}
                    </div>
                  ),
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
